export enum HallowAnalyticsHandler {
  Track = "track",
  TrackPayment = "trackPayment",
}
